class FakeVariantPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quickBuy = this.hasAttribute('quick_buy');
    this.buyButtons = document.querySelectorAll(
      '.product-info__block-item[data-block-id="buy_buttons"] button'
    );
    this.quickBuyButtons = this.closest('quick-buy-drawer')?.querySelectorAll(
      '.buy-buttons button'
    );
    this.soldOutBadge = this.closest(
      '.product-info__block-item[data-block-id="badges"]'
    )?.querySelector('sold-out-badge').parentElement;
    this.deliveryDetails = this.closest('.delivery-details');
    this.quickAddPDP = this.closest('product-quick-add');
    this.soldOut = this.querySelector('.variant_block.active')?.hasAttribute(
      'sold-out'
    );
    this.initialize();
  }

  initialize() {
    this.querySelectorAll('.variant_block').forEach((swatch, index) => {
      if (index == 0) swatch.classList.add('active');
      if (index > 0) swatch.classList.remove('active');
      if (!swatch.hasClickEvent) {
        swatch.addEventListener('click', (e) => {
          this.toggleClass(e);
          this.changePrice(e);
          this.changeQty(e);
          this.changeProperty(e);
          this.changeLegalText(e);
          this.toggleSoldOut(e.target.hasAttribute('sold-out'));
        });
        swatch.hasClickEvent = true;
      }
    });

    // Initial settings
    const hiddenQty = this.querySelector('#quantity-to-add');
    const valueQty = this.querySelector("input[name='amount']").value;
    hiddenQty.setAttribute('value', valueQty);
    hiddenQty.setAttribute('amount', valueQty);

    const propertyInput =
      document.querySelector('quick-buy-drawer #property-amount') ||
      document.querySelector('#property-amount');
    propertyInput.value = valueQty;

    if (!this.soldOut) {
      if (!this.quickBuy && this.soldOutBadge)
        this.soldOutBadge.setAttribute('hidden', '');
      if (this.quickBuy) {
        this.quickBuyButtons[1].setAttribute('hidden', '');
      } else {
        this.buyButtons[1].setAttribute('hidden', '');
      }
    } else {
      if (!this.quickBuy && this.deliveryDetails)
        this.deliveryDetails.setAttribute('hidden', '');
      if (!this.quickBuy && this.quickAddPDP)
        this.quickAddPDP.setAttribute('hidden', '');
      if (this.quickBuy) {
        this.quickBuyButtons[0].setAttribute('hidden', '');
      } else {
        this.buyButtons[0].setAttribute('hidden', '');
      }
    }
  }

  toggleClass(e) {
    this.querySelectorAll('.variant_block').forEach((el) =>
      el.classList.remove('active')
    );
    e.target.classList.add('active');
  }

  changePrice(e) {
    if (this.quickBuy) {
      const amount = e.target
        .querySelector("quick-buy-drawer input[name='price']")
        .getAttribute('value');
      const price = document.querySelector('quick-buy-drawer .price-to-change');
      if (price) price.innerHTML = amount;
    } else {
      const amount = e.target
        .querySelector("input[name='price']")
        .getAttribute('value');
      const price = document.querySelector('sale-price .price-to-change');
      if (price) price.innerHTML = amount;
    }
  }

  changeQty(e) {
    const amount = e.target
      .querySelector("input[name='amount']")
      .getAttribute('value');
    const valueQty = document.querySelector('.js-quantity')?.value;
    const valueHiddenQty = this.querySelector('#quantity-to-add');

    if (
      document.querySelector('quick-buy-drawer') &&
      document.querySelector('quick-buy-drawer').hasAttribute('open')
    ) {
      valueHiddenQty.setAttribute('amount', 1);
      valueHiddenQty.value = Number(amount);
    } else {
      if (valueQty) {
        valueHiddenQty.value = Number(amount) * Number(valueQty);
      } else {
        valueHiddenQty.value = Number(amount);
      }
      valueHiddenQty.setAttribute('amount', Number(amount));
    }
  }

  changeProperty(e) {
    const amount = e.target
      .querySelector("input[name='amount']")
      .getAttribute('value');
    const propertyInput =
      document.querySelector('quick-buy-drawer #property-amount') ||
      document.querySelector('#property-amount');
    propertyInput.value = amount;
  }
  changeLegalText(e) {
    const amount = e.target
      .querySelector("input[name='amount']")
      .getAttribute('value');
    const legalText = document.querySelector('.legal-text-crate');
    if (legalText && amount == 24) legalText.removeAttribute('hidden');
    if (legalText && amount != 24) legalText.setAttribute('hidden', '');
  }

  toggleSoldOut(isSoldOut) {
    if (this.soldOut !== isSoldOut) {
      if (this.quickBuy) {
        this.quickBuyButtons[0].toggleAttribute('hidden');
        this.quickBuyButtons[1].toggleAttribute('hidden');
      } else {
        this.buyButtons[0].toggleAttribute('hidden');
        this.buyButtons[1].toggleAttribute('hidden');
        if (this.soldOutBadge) this.soldOutBadge.toggleAttribute('hidden');
        if (this.quickAddPDP) this.quickAddPDP.toggleAttribute('hidden');
        if (this.deliveryDetails)
          this.deliveryDetails.toggleAttribute('hidden');
      }
      this.soldOut = !this.soldOut;
    }
  }
}

customElements.define('fake-variant-picker', FakeVariantPicker);

class LineItemMixMatch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bundleID = this.getAttribute('data-bundle-id');
    this.allLineItems = this.querySelectorAll('.mix-match-line-item');
    this.bundlePrice = this.querySelector('.bundle-price');
    this.bundlePricePlace = this.querySelector('.mix-and-match-price');
    this.updatePrice();
    this.querySelector('.to-open').addEventListener(
      'click',
      this.toggleOpen.bind(this)
    );
    this.querySelectorAll('.remove-mix_match').forEach((button) =>
      button.addEventListener('click', this.removeMixMatch.bind(this))
    );
  }

  updatePrice() {
    this.bundlePricePlace.innerHTML = this.bundlePrice.getAttribute('value');
  }

  toggleOpen() {
    this.toggleAttribute('open');
  }

  async removeMixMatch() {
    let updates = {};
    this.allLineItems.forEach((item) => {
      updates[item.getAttribute('data-line-item-key')] = 0;
    });
    let currentCart = await (
      await fetch(`${Shopify.routes.root}cart.json`)
    ).json();

    // Get the deposit type for this bundle (bottle or can)
    const depositType = this.getAttribute('data-deposit-type') || 'bottle';
    const bundleAmount = Number(this.getAttribute('data-amount'));

    currentCart.items.forEach((item) => {
      // Only subtract from the matching deposit type
      if (depositType === 'bottle' && item.id === window.depositBottle) {
        let newQty = item.quantity - bundleAmount;
        updates[item.key] = newQty;
      }
      if (depositType === 'can' && item.id === window.depositCan) {
        let newQty = item.quantity - bundleAmount;
        updates[item.key] = newQty;
      }
    });

    try {
      let updateResponse = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        }
      );

      let cartResponse = await fetch('/cart.json');
      let cartData = await cartResponse.json();

      document.documentElement.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            cart: {
              items: cartData.items,
            },
          },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        })
      );
    } catch (error) {
      console.error('Error:', error);
    }
  }
}

customElements.define('line-item-mix-match', LineItemMixMatch);

class TabComponent extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab');
    this.contents = this.querySelectorAll('.tab-content');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.tabs.forEach((t) => t.classList.remove('active'));
        this.contents.forEach((c) => c.classList.remove('active'));

        tab.classList.add('active');
        const targetContent = this.querySelector(`#${tab.dataset.tab}`);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }
}

customElements.define('tab-component', TabComponent);

class CollapsibleContent extends HTMLElement {
  connectedCallback() {
    this.textContainer = this.querySelector('#textContainer');
    this.toggleButton = this.querySelector('#toggleButton');
    this.buttonLess = this.dataset.buttonLess;
    this.buttonMore = this.dataset.buttonMore;

    this.toggleButton.addEventListener('click', () => {
      this.textContainer.classList.toggle('expanded');
      if (this.textContainer.classList.contains('expanded')) {
        this.toggleButton.textContent = this.buttonLess;
      } else {
        this.toggleButton.textContent = this.buttonMore;
      }
    });
  }
}

customElements.define('collapsible-content', CollapsibleContent);

// Buy Popup Modal logic
(() => {
  const focusableSelectors = [
    'a[href]','area[href]','input:not([disabled])','select:not([disabled])','textarea:not([disabled])','button:not([disabled])','iframe','object','embed','[contenteditable]','[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function openModal(modal) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    const firstFocusable = modal.querySelector(focusableSelectors);
    modal.dataset.previousFocus = document.activeElement ? '1' : '';
    setTimeout(() => firstFocusable?.focus(), 0);
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal(modal, triggerButton) {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    triggerButton?.focus();
  }

  function getTriggerButton(container) {
    return container.querySelector('.button');
  }

  document.addEventListener('click', (e) => {
    const triggerContainer = e.target.closest('.buy_pop-up_button');
    if (triggerContainer) {
      const triggerBtn = getTriggerButton(triggerContainer);
      const isButton = triggerBtn && triggerBtn.contains(e.target);
      if (isButton) {
        if (!triggerBtn.hasAttribute('disabled')) {
          const controls = triggerBtn.getAttribute('aria-controls');
          const modal = controls && document.getElementById(controls);
          openModal(modal);
          e.preventDefault();
        }
      }
    }

    const closeBtn = e.target.closest('.js-buy-popup-close');
    const backdrop = e.target.classList?.contains('buy-popup-backdrop') ? e.target : null;
    const buyButtons = e.target.closest('.product-info__buy-buttons');
    if (closeBtn || backdrop || buyButtons) {
      console.log('closeBtn', closeBtn);
      const modal = document.querySelector('.buy-popup-modal');
      const container = modal?.previousElementSibling?.closest('.buy_pop-up_button') || document.querySelector('.buy_pop-up_button');
      const triggerBtn = container ? getTriggerButton(container) : null;
      closeModal(modal, triggerBtn);
    }

    // const backdrop = e.target.classList?.contains('buy-popup-backdrop') ? e.target : null;
    // if (backdrop) {
    //   const modal = backdrop.closest('.buy-popup-modal');
    //   const container = modal?.previousElementSibling?.closest('.buy_pop-up_button') || document.querySelector('.buy_pop-up_button');
    //   const triggerBtn = container ? getTriggerButton(container) : null;
    //   closeModal(modal, triggerBtn);
    // }
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.buy-popup-modal[aria-hidden="false"]').forEach((modal) => {
        const container = modal.previousElementSibling?.closest('.buy_pop-up_button') || document.querySelector('.buy_pop-up_button');
        const triggerBtn = container ? getTriggerButton(container) : null;
        closeModal(modal, triggerBtn);
      });
    }

    if (e.key === 'Tab') {
      const modal = document.querySelector('.buy-popup-modal[aria-hidden="false"]');
      if (!modal) return;
      const focusables = Array.from(modal.querySelectorAll(focusableSelectors)).filter(el => el.offsetParent !== null);
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
